export const isPinFieldFilled = (
  value: string | null | undefined,
): boolean => value != null && String(value).trim() !== "";

export const countFilledPinFields = (data: {
  pinCoordinateSystem?: string | null;
  pinE?: string | null;
  pinN?: string | null;
}): number =>
  [data.pinCoordinateSystem, data.pinE, data.pinN].filter(isPinFieldFilled)
    .length;
